import { savePrescription, getPrescription, getConsultationById, saveUploadedPrescriptionUrl } from "../../../Common/axios_instance/video_https/video.https";
import { uploadPrescriptionFile } from "../../../Common/axios_instance/azure_https/azure.https";

export const fetchConsultation = (id: string) => getConsultationById(id);

export const fetchPrescription = (id: string) => getPrescription(id);

export const savePrescriptionData = (id: string, payload: any) => savePrescription(id, payload);

export const uploadPrescriptionDocument = async (file: File, beneficiaryId: string, consultationId: string) => {
  // 1. Upload file to Azure blob storage
  const uploadRes = await uploadPrescriptionFile(file, beneficiaryId, file.name);
  const uploadedUrl: string = uploadRes.data?.data?.url;
  if (!uploadedUrl) throw new Error('No URL returned from upload');

  // 2. Save the URL back to the Prescription record in video service
  await saveUploadedPrescriptionUrl(consultationId, uploadedUrl);

  return uploadedUrl;
};
